export const CurriculumChip = {
  methods: {
    showChip (curriculum) {
      return curriculum.fields['Is Sexual Harassment Training'] ||
             curriculum.fields['Is Manager Training'] ||
             curriculum.fields['Is Diversity Training'] || 
             curriculum.fields['Is COVID-19 Training']
    },
    getChipText (curriculum) {
      if (curriculum.fields['Is Sexual Harassment Training']) {
        return 'Sexual Harassment Training'
      } else if (curriculum.fields['Is Manager Training']) {
        return 'Manager Training'
      } else if (curriculum.fields['Is Diversity Training']) {
        return 'Diversity Training'
      } else if (curriculum.fields['Is COVID-19 Training']) {
        return 'COVID-19 Training'
      } else {
        return ''
      }
    }
  }
}
